module.exports = __webpack_public_path__ + "img/ic_16_arrow_right.bb919f8f.svg";